import { render } from "./header_message.vue?vue&type=template&id=50ec598a"
import script from "./header_message.vue?vue&type=script&lang=js"
export * from "./header_message.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__